module.exports = __webpack_public_path__ + "img/positive.57b2390a.svg";